import { useMutation, useQueryClient } from 'react-query';

import appConfig from 'src/core/config';
import { useCompanyId } from 'src/core/modules/app/hooks/useCompanyId';

const migrateToApprovalWorkflow = async (companyId: string): Promise<void> => {
  const response = await fetch(
    `${appConfig.apiUrls.apiV2}/${companyId}/approval-workflows/migrate`,
    {
      method: 'POST',
      credentials: 'include',
    },
  );
  if (!response.ok) {
    throw new Error('Failed to migrate to approval workflow');
  }
};

export const useMigrateToApprovalWorkflow = () => {
  const companyId = useCompanyId();
  const queryClient = useQueryClient();

  return useMutation(() => migrateToApprovalWorkflow(companyId), {
    onSuccess: () => {
      queryClient.invalidateQueries(['approval-workflows', 'active']);
    },
  });
};
